import use4PreSubmit from '@/composables/preSubmit/use4PreSubmit.js'
import use663PreSubmit from '@/composables/preSubmit/use663PreSubmit'
import use713PreSubmit from '@/composables/preSubmit/use713PreSubmit'
import use714PreSubmit from '@/composables/preSubmit/use714PreSubmit'
import use719PreSubmit from '@/composables/preSubmit/use719PreSubmit'
import use838PreSubmit from '@/composables/preSubmit/use838PreSubmit'
import use148PreSubmit from '@/composables/preSubmit/use148PreSubmit'
import use693PreSubmit from '@/composables/preSubmit/use693PreSubmit'
import use919PreSubmit from '@/composables/preSubmit/use919PreSubmit'
import use573PreSubmit from '@/composables/preSubmit/use573PreSubmit'
import use1120PreSubmit from '@/composables/preSubmit/use1120PreSubmit'
import use572PreSubmit from '@/composables/preSubmit/use572PreSubmit'
import use430PreSubmit from '@/composables/preSubmit/use430PreSubmit'
import use417PreSubmit from '@/composables/preSubmit/use417PreSubmit'
import use632PreSubmit from '@/composables/preSubmit/use632PreSubmit'
import use480PreSubmit from '@/composables/preSubmit/use480PreSubmit'
import use767PreSubmit from '@/composables/preSubmit/use767PreSubmit'

export default async function (serviceId, payload) {
  const mapping = {
    4: use4PreSubmit,
    148: use148PreSubmit,
    663: use663PreSubmit,
    693: use693PreSubmit,
    713: use713PreSubmit,
    714: use714PreSubmit,
    719: use719PreSubmit,
    919: use919PreSubmit,
    838: use838PreSubmit,
    573: use573PreSubmit,
    480: use480PreSubmit,
    1120: use1120PreSubmit,
    572: use572PreSubmit,
    430: use430PreSubmit,
    417: use417PreSubmit,
    632: use632PreSubmit,
    767: use767PreSubmit
  }
  if (
    Object.keys(mapping)
      .map((m) => +m)
      .includes(+serviceId)
  ) {
    return await mapping[serviceId](payload)
  }

  console.info(`There's no pre submit mapped for ${serviceId}`)
  return Promise.resolve({})
}
